<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_bell_delete_auth'">
                </div>
                <hr class="dialog-hr">
                <div class="confirm-body" v-html="$t('message.info_bell_delete_auth', { userName: this.confirmInfo.user.userName })">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('delete')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        confirmInfo: Object,
    },

    data() {
        return {
        };
    },

    created() {
    },
}
</script>

<style scoped>


</style>
